module.exports = __webpack_public_path__ + "media/cross_sell/Become_an_EJW_Customer-03338cd6.png";